import { render, staticRenderFns } from "./UpdateNe.vue?vue&type=template&id=21c8241e&"
import script from "./UpdateNe.vue?vue&type=script&lang=js&"
export * from "./UpdateNe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports